<template>
  <div class="search-bar d-flex align-items-center">
    <div>
      <div
        v-if="search"
        class="n-icon-wrap d-flex align-items-center justify-content-center search"
        @click="search = null"
      >
        <i class="far fa-times"></i>
      </div>
      <div v-else class="n-icon-wrap d-flex align-items-center justify-content-center">
        <i class="far fa-search o70"></i>
      </div>
    </div>

    <input type="text" :placeholder="placeholder" class="form-control" v-model="search">
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "Search for a result..."
    }
  },
  computed: {
    search: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-bar {
  position: relative;
}
.n-icon-wrap {
  height: 39px;
  width: 39px;
  position: absolute;
  right: 0px;
  top: 0px;

  &.search {
    cursor: pointer;

    i {
      font-size: 1.125rem;
    }
  }
}

.search-bar input {
  font-size: 0.875rem;
}

.card input.form-control {
  width: 15rem;
}
</style>
